import React from 'react';

const Alert: React.FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1.5C4.41594 1.5 1.5 4.41594 1.5 8C1.5 11.5841 4.41594 14.5 8 14.5C11.5841 14.5 14.5 11.5841 14.5 8C14.5 4.41594 11.5841 1.5 8 1.5ZM8 11.4972C7.87639 11.4972 7.75555 11.4605 7.65277 11.3919C7.54999 11.3232 7.46988 11.2256 7.42258 11.1114C7.37527 10.9972 7.36289 10.8715 7.38701 10.7503C7.41112 10.629 7.47065 10.5177 7.55806 10.4302C7.64547 10.3428 7.75683 10.2833 7.87807 10.2592C7.99931 10.2351 8.12497 10.2475 8.23918 10.2948C8.35338 10.3421 8.45099 10.4222 8.51967 10.525C8.58834 10.6277 8.625 10.7486 8.625 10.8722C8.625 11.0379 8.55915 11.1969 8.44194 11.3141C8.32473 11.4313 8.16576 11.4972 8 11.4972ZM8.67875 5.21125L8.49938 9.02375C8.49938 9.15636 8.4467 9.28354 8.35293 9.3773C8.25916 9.47107 8.13198 9.52375 7.99937 9.52375C7.86677 9.52375 7.73959 9.47107 7.64582 9.3773C7.55205 9.28354 7.49937 9.15636 7.49937 9.02375L7.32 5.21313V5.21156C7.31607 5.11998 7.33071 5.02854 7.36305 4.94277C7.39539 4.85699 7.44475 4.77865 7.50817 4.71245C7.57158 4.64626 7.64774 4.59358 7.73205 4.55759C7.81636 4.5216 7.90708 4.50305 7.99875 4.50305C8.09042 4.50305 8.18114 4.5216 8.26545 4.55759C8.34976 4.59358 8.42592 4.64626 8.48933 4.71245C8.55275 4.77865 8.60211 4.85699 8.63445 4.94277C8.66679 5.02854 8.68143 5.11998 8.6775 5.21156L8.67875 5.21125Z"
        fill="#C51414"
      />
    </svg>
  );
};

export default Alert;
